module.exports = __webpack_public_path__ + "static/pattern-design-suggestion-990f6c5aee96bf3f8d23a3fdbc0fc4d5.png";